import * as z from "zod";
import { linnworksReturnsSettingsSchema } from "./linnworks-returns-settings-schema";

export const setLinnworksReturnsSettings = {
  name: "setLinnworksReturnsSettings" as const,
  input: linnworksReturnsSettingsSchema,
  output: z.object({ success: z.boolean() }),
};
